import resizeObserver from "shared/resizeObserver";

export default function refresh() {
  if (this.store.loadingMeasurements) return;
  clearInterval(this.updateStripInterval);
  this.store._measurements = { data: [] };

  this.store
    .fetchMonitorMeasurements({
      starttime: this.store.stripStartTime,
      endtime: this.store.stripEndTime,
    })
    .then(() => {
      clearInterval(this.updateStripInterval);
      this.updateStripInterval = setInterval(
        this.updateStripBuffer.bind(this),
        1000,
      );
    });
  requestAnimationFrame(() => {
    if (this.refChart) resizeObserver.observe(this.refChart, this.setChartSize);
  });
}
